import React, { useEffect, useState } from 'react';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import { listDocs, createDoc, updateDocById, deleteDocById } from '../services/dbService';
import ImageUpload from '../components/ImageUpload';
import toast from 'react-hot-toast';
import './Events.css';

const Advertisements = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ title: '', description: '', imageUrl: '', colorHex: '#ffffff', isActive: true });

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      setLoading(true);
      const docs = await listDocs('advertisements');
      setAds(docs.map(d => ({
        ...d,
        isActive: d.is_active !== undefined ? d.is_active : d.isActive
      })));
    } catch (err) {
      console.error(err);
      toast.error('Failed to load advertisements');
    } finally {
      setLoading(false);
    }
  };

  const openModal = (a = null) => {
    if (a) {
      setEditing(a);
      setForm({ title: a.title || '', description: a.description || '', imageUrl: a.imageUrl || '', colorHex: a.colorHex || '#ffffff', isActive: !!a.isActive });
    } else {
      setEditing(null);
      setForm({ title: '', description: '', imageUrl: '', colorHex: '#ffffff', isActive: true });
    }
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await updateDocById('advertisements', editing.id, {
          title: form.title,
          description: form.description,
          imageUrl: form.imageUrl,
          colorHex: form.colorHex,
          is_active: form.isActive
        });
        toast.success('Advertisement updated');
      } else {
        await createDoc('advertisements', {
          title: form.title,
          description: form.description,
          imageUrl: form.imageUrl,
          colorHex: form.colorHex,
          is_active: form.isActive,
          created_at: new Date().toISOString()
        });
        toast.success('Advertisement created');
      }
      setShowModal(false);
      fetchAds();
    } catch (err) {
      console.error(err);
      toast.error('Failed to save advertisement');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this advertisement?')) return;
    try {
      await deleteDocById('advertisements', id);
      toast.success('Advertisement deleted');
      fetchAds();
    } catch (err) {
      console.error(err);
      toast.error('Failed to delete advertisement');
    }
  };

  const toggleActive = async (ad) => {
    try {
      await updateDocById('advertisements', ad.id || ad._id, { is_active: !ad.isActive });
      fetchAds();
    } catch (err) {
      console.error(err);
      toast.error('Failed to update advertisement');
    }
  };

  if (loading) return <div className="events-container"><p>Loading...</p></div>;

  return (
    <div className="events-container">
      <div className="events-header">
        <h1>Advertisements</h1>
        <button className="btn btn-primary" onClick={() => openModal()}>
          <FiPlus /> Add Ad
        </button>
      </div>

      <div className="events-table-wrapper">
        <table className="events-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Active</th>
              <th>Image</th>
              <th>Color</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {ads.length > 0 ? (
              ads.map((a) => (
                <tr key={a.id}>
                  <td>{a.title}</td>
                  <td>{a.isActive ? 'Yes' : 'No'}</td>
                  <td>{a.imageUrl ? <img src={a.imageUrl} alt="img" style={{ width: 80, height: 50, objectFit: 'cover' }} /> : 'N/A'}</td>
                  <td><div style={{ width: 30, height: 20, background: a.colorHex }} /></td>
                  <td className="action-buttons">
                    <button className="btn btn-sm btn-info" onClick={() => openModal(a)}>
                      <FiEdit2 /> Edit
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(a.id)}>
                      <FiTrash2 /> Delete
                    </button>
                    <button className="btn btn-sm btn-secondary" onClick={() => toggleActive(a)}>
                      {a.isActive ? 'Disable' : 'Enable'}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No advertisements found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editing ? 'Edit Advertisement' : 'Add Advertisement'}</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="event-form">
              <div className="form-group">
                <label>Title *</label>
                <input type="text" name="title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea name="description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows="2" />
              </div>

              <div className="form-group">
                <label>Image</label>
                <ImageUpload onUpload={(url) => setForm({ ...form, imageUrl: url })} initialUrl={form.imageUrl} path="ads" />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Color</label>
                  <input type="color" value={form.colorHex} onChange={(e) => setForm({ ...form, colorHex: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Active</label>
                  <select value={form.isActive ? 'true' : 'false'} onChange={(e) => setForm({ ...form, isActive: e.target.value === 'true' })}>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">{editing ? 'Update' : 'Create'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Advertisements;